var elem = document.querySelector('.custom-icons-wrapper .section-content-wrapper');
var flkty = new Flickity( elem, {
  cellAlign: 'left',
  contain: true,
  groupCells: true,
  autoPlay: true
});

const elem_tratamientos = document.querySelector('.tratamientos-packs .section-content-wrapper');
const flkty_tratamientos = new Flickity( elem_tratamientos, {
  cellAlign: 'left',
  watchCSS: true,
  contain: true,
  autoPlay: true,
  pageDots: false
});